import { selectBalancingQuest } from "../balancingSelectors/selectBalancingQuests";
import { QuestStateType } from "../utils/network/generated/protoTypes";
import { utilTime } from "../utils/utilTime";
var QuestPriorityNotRecommended = 999;
export var questPrioritySorter = function (a, b) {
    if (a.priority === b.priority) {
        return (b.xp ? b.xp.amount : 0) - (a.xp ? a.xp.amount : 0);
    }
    return (b.priority || -1) - (a.priority || -1);
};
export var questFilter = function (quest, playerLevel, adventurerLevel, farmId, questEndTime) {
    var requiredPlayerLevel = 0;
    var requiredAdventurerLevel = 0;
    var removalPlayerLevel = playerLevel;
    var showOnFarmId = farmId;
    if (quest.unlockRequirement != undefined) {
        requiredPlayerLevel = quest.unlockRequirement.playerLevel || 0;
        requiredAdventurerLevel = quest.unlockRequirement.adventurerLevel || 0;
    }
    if (quest.removalCondition != undefined) {
        removalPlayerLevel = quest.removalCondition.playerLevel || playerLevel;
    }
    if (quest.showMeOnFarmId != undefined) {
        showOnFarmId = quest.showMeOnFarmId;
    }
    var hasTimeLeft = true;
    if (questEndTime && questEndTime < utilTime.now()) {
        hasTimeLeft = false;
    }
    return (!quest.hideOnWeb &&
        playerLevel >= requiredPlayerLevel &&
        adventurerLevel >= requiredAdventurerLevel &&
        playerLevel <= removalPlayerLevel &&
        farmId === showOnFarmId &&
        hasTimeLeft);
};
export var selectQuestInfo = function (state) {
    var playerLevel = state.playerInfo.level;
    var adventurerLevel = state.playerInfo.adventurerLevel;
    var farmId = state.playerBase.base.baseId || 1;
    var availableQuests = [];
    var completedQuests = [];
    var completedQuestIds = [];
    if (state.questInfo.quest != undefined) {
        state.questInfo.quest.forEach(function (value) {
            var questBalancingInfo = selectBalancingQuest(value.questId);
            var questEndTime = value.hasRemainingTime ? value.endTime : undefined;
            if (questBalancingInfo != undefined &&
                questFilter(questBalancingInfo, playerLevel, adventurerLevel, farmId, questEndTime)) {
                if (value.state !== QuestStateType.COMPLETE) {
                    availableQuests.push(questBalancingInfo);
                }
                else if (value.state === QuestStateType.COMPLETE) {
                    completedQuests.push(questBalancingInfo);
                    completedQuestIds.push(questBalancingInfo.id);
                }
            }
        });
    }
    availableQuests = availableQuests.sort(questPrioritySorter);
    completedQuests = completedQuests.sort(questPrioritySorter);
    var recommendedQuest = getRecommendedQuest(availableQuests, completedQuests);
    var recommendedQuestId = recommendedQuest ? recommendedQuest.id : -1;
    return {
        availableQuests: availableQuests,
        completedQuestIds: completedQuestIds,
        completedQuests: completedQuests,
        recommendedQuest: recommendedQuest,
        recommendedQuestId: recommendedQuestId,
    };
};
export var selectSortedQuest = function (state) {
    var _a = selectQuestInfo(state), completedQuests = _a.completedQuests, availableQuests = _a.availableQuests;
    return completedQuests.concat(availableQuests);
};
export var selectQuestIds = function (state) {
    var quests = state.questInfo.quest || [];
    return quests.map(function (value) { return value.questId; });
};
export var getRecommendedQuest = function (availableQuests, completedQuests) {
    var recommendedQuest;
    var isRecommendedQuestFromAvailableQuest;
    if (availableQuests.length === 0 && completedQuests.length === 0) {
        return;
    }
    var indexAvailable = availableQuests.findIndex(function (value) { return !value.ignoreReco; });
    var indexCompleted = completedQuests.findIndex(function (value) { return !value.ignoreReco; });
    if (indexAvailable >= 0 && indexCompleted >= 0) {
        isRecommendedQuestFromAvailableQuest =
            questPrioritySorter(availableQuests[indexAvailable], completedQuests[indexCompleted]) <
                0;
    }
    else if (indexAvailable >= 0) {
        isRecommendedQuestFromAvailableQuest = true;
    }
    else if (indexAvailable < 0 && indexCompleted < 0) {
        var idx = availableQuests.findIndex(function (value) { return value.priority !== QuestPriorityNotRecommended; });
        recommendedQuest = availableQuests.splice(idx, 1)[0];
        return recommendedQuest;
    }
    if (isRecommendedQuestFromAvailableQuest) {
        recommendedQuest = availableQuests.splice(indexAvailable, 1)[0];
    }
    else {
        recommendedQuest = completedQuests.splice(indexCompleted, 1)[0];
    }
    return recommendedQuest;
};
export var selectNewQuestIds = function (state) {
    return state.questInfo.newQuestIds;
};
export var selectQuestInfoTasks = function (state) {
    var questInfoTaskMap = new Map();
    if (state.questInfo.quest != undefined) {
        state.questInfo.quest
            .filter(function (value) { return value.state !== QuestStateType.COMPLETE; })
            .forEach(function (value) {
            questInfoTaskMap.set(value.questId, value.task);
        });
    }
    return questInfoTaskMap;
};
export var selectSelectedQuest = function (state) {
    var selectedQuest = state.questInfo.selectedQuest;
    var _a = selectQuestInfo(state), completedQuests = _a.completedQuests, recommendedQuest = _a.recommendedQuest;
    if (selectedQuest === undefined) {
        if (completedQuests.length > 0) {
            selectedQuest = completedQuests[0];
        }
        else if (recommendedQuest != undefined) {
            selectedQuest = recommendedQuest;
        }
    }
    return selectedQuest;
};
export var selectIsQuestCompleted = function (state, quest) {
    var completedQuestIds = selectQuestInfo(state).completedQuestIds;
    return completedQuestIds.indexOf(quest.id) !== -1;
};
export var selectIsQuestNew = function (state, quest) {
    var newQuestIds = selectNewQuestIds(state);
    return newQuestIds.indexOf(quest.id) !== -1;
};
export var selectIsAnyQuestNew = function (state) {
    return selectSortedQuest(state).some(function (z) { return selectIsQuestNew(state, z); });
};
export var selectIsQuestAvailable = function (state, questId) {
    var availableQuests = selectQuestInfo(state).availableQuests;
    return availableQuests.some(function (quest) { return quest.id === questId; });
};
export var selectIsQuestRecommended = function (state, questId) {
    var recommendedQuest = selectQuestInfo(state).recommendedQuest;
    return recommendedQuest != undefined && recommendedQuest.id === questId;
};
export var selectIsQuestListed = function (state, questId) {
    var questAvailable = selectIsQuestAvailable(state, questId);
    var questRecommended = selectIsQuestRecommended(state, questId);
    return questAvailable || questRecommended;
};
export var selectIsAnyQuestCompleted = function (state) {
    return selectQuestInfo(state).completedQuestIds.length > 0;
};
export var selectNewOrCompletedQuestsOutsideOfPage = function (state) { return function (config) {
    var step = config.step, page = config.page, perPage = config.perPage, pageCount = config.pageCount;
    var quests = selectSortedQuest(state);
    var newQuests = selectNewQuestIds(state);
    var completedQuestIds = selectQuestInfo(state).completedQuestIds;
    var nextPage = page + step;
    // pager button won't be rendered
    if ((nextPage < 0 && step < 0) || (nextPage > pageCount - 1 && step > 0)) {
        return false;
    }
    // no new or completed quests
    if (!selectIsAnyQuestNew(state) && !selectIsAnyQuestCompleted(state)) {
        return false;
    }
    var matching = newQuests.concat(completedQuestIds);
    var asc = step > 0;
    var nextRange = asc ? quests.slice(perPage + page) : quests.slice(0, page);
    return nextRange.some(function (q) { return matching.indexOf(q.id) > -1; });
}; };
export var filterNewQuests = function (state, questParams, resQuestId) {
    if (resQuestId === void 0) { resQuestId = -1; }
    var oldQuests = state.questInfo.quest;
    var questsMap = new Map();
    var newReceivedQuestIds = [];
    var notViewedQuestIds = state.questInfo.newQuestIds;
    if (oldQuests != undefined && resQuestId != undefined) {
        oldQuests.forEach(function (val) {
            if (val.questId !== resQuestId) {
                questsMap.set(val.questId, val);
            }
        });
    }
    if (questParams !== undefined) {
        questParams.forEach(function (value) {
            if (!questsMap.has(value.questId)) {
                newReceivedQuestIds.push(value.questId);
                questsMap.set(value.questId, value);
            }
        });
    }
    var newQuestIds = newReceivedQuestIds.concat(notViewedQuestIds);
    return {
        newQuestIds: newQuestIds,
        newReceivedQuestIds: newReceivedQuestIds,
        notViewedQuestIds: notViewedQuestIds,
    };
};
export var selectQuestEndTime = function (state, id) {
    var quest = state.questInfo.quest.find(function (q) { return q.questId === id; });
    return quest && quest.endTime ? quest.endTime : undefined;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectQuestInfo.ts
// module id = 181
// module chunks = 3